import React from "react";
import "whatwg-fetch";
import * as serviceWorker from "./serviceWorker";
import { Amplify } from "aws-amplify";
import Modal from "react-modal";
import { Provider } from "react-redux";
import { createRoot } from 'react-dom/client';
import {
    DesignTokensProvider,
    DesignTokensGlobalStyles,
    BOI_THEME_TOKENS
  } from "@boi/react-design-tokens";

import "@boi/fonts";

import App from "./components/app/app";
import config from "./aws-exports";
import configureStore from "./components/app/app-store";
import './fonts/fonts.css';

Amplify.configure(config);
Modal.setAppElement("#root");

export default function() {
    createRoot(document.getElementById("root")).render(
        <Provider store={configureStore()}>
            <DesignTokensProvider themeTokens={BOI_THEME_TOKENS} theme="light">
                <DesignTokensGlobalStyles />
                <App />
            </DesignTokensProvider>
        </Provider>
    );
}

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();